import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/backups',
)({
  // Overrides the inherited `cluster` domain — the backups feature has its own owner.
  staticData: {
    domain: 'backups',
  },
  component: lazyRouteComponent(() => import('./backups.component'), 'BackupsComponent'),
});
